import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ limage, dimage, simage }) => {
    return (
        <Link to={ "/"}>
            {limage && (
                <img
                    className="light-version-logo"
                    src={ limage}
                    alt="logo"
                />
            )}
            {dimage && (
                <img
                    className="dark-version-logo"
                    src={ dimage}
                    alt="logo"
                />
            )}
            {simage && (
                <img
                    className="sticky-logo"
                    src={ simage}
                    alt="logo"
                />
            )}
        </Link>
    );
};

export default Logo;
